// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pale[data-v-1fe80a42] {\n  opacity: 0.5;\n}\n", ""]);
// Exports
module.exports = exports;
